import swal from "sweetalert";
import axiosInstance from "../api";
import { GET_SETTING } from "../constants";
import { setCategoryList, setDeliveryCharges } from "../../deliverySlice";
import { setCustomerDetails, setCustomerList, setFaqData, setTermAndConditionData } from "../../reusableSlice";

export const getSettings = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get("admin/settings/");
    if (response?.data?.status) {
      dispatch({ type: GET_SETTING, settinglist: response?.data?.response });
      return response;
    }
    swal({
      text: response?.data?.response?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
   // console.error(err);
  } finally {
  }
};

export const updateSetting = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("admin/settings/", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      // window.location.reload()
      // return response;
    }
   else{
    swal({
      text: response?.data?.response?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
   }
  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};

// TODO: No backend route for delivery_charge in the Nysmah spec.
// This endpoint will 404 until a backend route is added.
export const getDeliveryCharges = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get("delivery_charge/get_all");

    if (response?.data?.status) {
      dispatch(setDeliveryCharges(response?.data.response));
      return response;
    }
   else{
    swal({
      text: response?.data?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
   }
  } catch (err) {
   // console.error(err);
  } finally {
  }
};

// TODO: No backend route for business/get_categories_by_gender in the Nysmah spec.
export const getCategories = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(
      "business/get_categories_by_gender",
      data,
    );

    if (response?.data?.status) {
      dispatch(setCategoryList(response?.data.response));
      return response;
    }
  else{
    dispatch(setCategoryList([]));
  }
  } catch (err) {
   // console.error(err);
    dispatch(setCategoryList([]));
  }
};


// TODO: No backend route for delivery_charge in the Nysmah spec.
export const updateDeliveryCharges = (data, setLoading) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("delivery_charge/update", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      return response;
    }
    swal({
      text: response?.data?.response?.message,

      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};



export const getContactDetails = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get("admin/settings/contact-detail");

    if (response?.data?.status) {
      dispatch(setCustomerDetails(response?.data.response));
      return response;
    }
   else{
    swal({
      text: response?.data?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
   }
  } catch (err) {
   // console.error(err);
  } finally {
  }
};


export const updateContactDetails = (data, setLoading) => async (dispatch) => {
  try {
    const response = await axiosInstance.put("admin/settings/contact-detail", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      return response;
    }
    swal({
      text: response?.data?.response?.message,

      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};



export const getContactList = (params) => async (dispatch) => {
  try {
    const response = await axiosInstance.get("admin/settings/contact-inquiries", { params });

    if (response?.data?.status) {
      dispatch(setCustomerList(response?.data.response));
      return response;
    }
   else{
    swal({
      text: response?.data?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
   }
  } catch (err) {
   // console.error(err);
  } finally {
  }
};


export const getFaq = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get("admin/settings/faq");

    if (response?.data?.status) {
      dispatch(setFaqData(response?.data.response));
      return response;
    }
   else{
    swal({
      text: response?.data?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
   }
  } catch (err) {
   // console.error(err);
  } finally {
  }
};

export const updateFaq = (data, setLoading) => async (dispatch) => {
  try {
    const response = await axiosInstance.put("admin/settings/faq", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      return response;
    }
    swal({
      text: response?.data?.response?.message,

      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};

export const getTermAndCondition = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get("admin/settings/terms");

    if (response?.data?.status) {
      dispatch(setTermAndConditionData(response?.data.response));
      return response;
    }
   else{
    swal({
      text: response?.data?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
   }
  } catch (err) {
   // console.error(err);
  } finally {
  }
};

export const updateTermAndCondition = (data, setLoading) => async (dispatch) => {
  try {
    const response = await axiosInstance.put("admin/settings/terms", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      return response;
    }
    swal({
      text: response?.data?.response?.message,

      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
   // console.error(err);
  } finally {
    setLoading(false);
  }
};


export const updateContactStatus = (payload) => async (dispatch) => {
  try {
    const response = await axiosInstance.patch("admin/settings/contact-inquiries/status", payload);
   if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      return response;
    }
    swal({
      text: response?.data?.response?.message,

      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (error) {
    console.error("Error updating status:", error);
  }
};

// Delivery outcomes reported back by the mail provider. Read-only, and
// deliberately not pushed into a shared slice: nothing else needs this data,
// so the page holds it in local state and this just returns it.
export const getEmailEvents = (params) => async () => {
  try {
    const response = await axiosInstance.get("admin/settings/email-events", {
      params,
    });
    if (response?.data?.status) {
      return response?.data?.response;
    }
    swal({
      text: response?.data?.response?.message || "Could not load email events",
      icon: "error",
      button: "Close",
      timer: 1500,
    });
    return null;
  } catch (err) {
    return null;
  }
};
